"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const AmountInput = props => {
    const { name = "amount", getCurrentBalance, symbol, decimals, readOnly } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [maxValue, setMaxValue] = (0, react_1.useState)(null);
    const contractId = (0, react_hook_form_1.useWatch)({ name: "contractId" });
    (0, react_1.useEffect)(() => {
        if (!getCurrentBalance || !contractId || decimals === undefined) {
            return;
        }
        void getCurrentBalance(decimals).then((balance) => {
            setMaxValue(balance);
        });
    }, [contractId, getCurrentBalance, decimals]);
    const label = formatMessage({ id: `form.labels.${name}` });
    const helperAmountText = (0, react_1.useMemo)(() => formatMessage({ id: "form.hints.maxValue" }, { label, value: maxValue }), [maxValue]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { position: "relative" }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { display: "flex", justifyContent: "flex-end", position: "absolute", top: 4, right: 0 }, children: maxValue ? (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: helperAmountText }) : null }), (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.EthInput, { name: name, units: decimals, symbol: symbol, readOnly: readOnly })] }));
};
exports.AmountInput = AmountInput;
//# sourceMappingURL=index.js.map